export const STOP_IMAGES = {
  signature: "Signature",
  physicaldr: "Physical DR",
  proofofdelivery: "Proof of Delivery",
  trailer: "Trailer",
};

export const PRO_IMAGES = {
  exception: "Exception",
  excessivelength: "Excessive Length",
  tallycount: "Tally Count",
  suffixpro: "Suffix Pro",
  canadapro: "Canada Pro",
  bol: "Bill Of Lading",
  hazmat: "Hazmat",
  edr : "EDR"
};

export const downloadBlobDataByURLs = (imageURLs) => {
  return Promise.all(
    imageURLs.map((url) =>
      fetch(url).then((res) => {
        if (res.status === 200) {
          return res.text();
        } else {
          throw new Error("file load error");
        }
      })
    )
  );
};

export function getImagesFromBlobStorage({
  folderName,
  imageData,
  updateFunction,
  handleError,
  fileType
}) {
  let populatedImageData = {};
  Promise.all(
    Object.keys(imageData).map((imageKeyName) => {
      return downloadBlobDataByURLs(imageData[imageKeyName]).then((images) => {
        images.forEach((image) => {
          populatedImageData = {
            ...populatedImageData,
            [imageKeyName]: [
              ...((populatedImageData && populatedImageData[imageKeyName]) ??
                []),
              `${fileType}${image}`,
            ],
          };
        });
      });
    })
  )
    .then((_responses) => {
      updateFunction(folderName, populatedImageData);
    })
    .catch((error) => {
      handleError();
      console.log(error);
    });
}
